/**
 * Use Cookie Consent Hook
 * Global hook to manage cookie consent modal visibility and state
 */

import { useCallback, useEffect, useState } from "react";
import { hasUserRespondedToCookieConsent } from "../helpers/cookie-consent/cookie-consent.helper";

interface UseCookieConsentReturn {
  showConsentModal: boolean;
  closeConsentModal: () => void;
}

export const useCookieConsent = (): UseCookieConsentReturn => {
  const [showConsentModal, setShowConsentModal] = useState(false);

  useEffect(() => {
    // Check if user has already responded to cookie consent
    const hasResponded = hasUserRespondedToCookieConsent();

    // Show modal only if user hasn't responded yet
    if (!hasResponded) {
      // Delay showing modal slightly to ensure app is fully loaded
      const timer = setTimeout(() => {
        setShowConsentModal(true);
      }, 500);

      return () => clearTimeout(timer);
    }

    return undefined;
  }, []);

  const closeConsentModal = useCallback(() => {
    setShowConsentModal(false);
  }, []);

  return {
    showConsentModal,
    closeConsentModal,
  };
};
